import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { downloadReport } from 'redux/report/ReportActions';
import ReportsGrid from './ReportsGrid';

const mapDispatchToProps = dispatch => ({
  filesActions: bindActionCreators({ downloadReport }, dispatch)
});

export default connect(null, mapDispatchToProps)(ReportsGrid);


// WEBPACK FOOTER //
// ./src/shared/components/reportGrid/ReportsGridConnector.js